<ctx-algolia-media-thumbnail [media]="media()" />

<div class="global-search-media__information">
	<p class="m-0">
		<tui-icon icon="@tui.file" />
		{{ media().name }}
	</p>

	<small class="m-0">
		{{
			'data.last-edited-at'
				| transloco: { time: updatedAt() | relativeTime }
		}}
	</small>
</div>

<div class="global-search-media__actions">
	<span tuiBadge appearance="info">
		<tui-icon icon="@tui.sprout" />

		<span class="global-search-media__actions-badge-text">
			{{ media().metadata.parentName }}
		</span>
	</span>
</div>
